import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import {
  selectPaymentType,
  selectPlanDetails,
  selectPlans,
  selectSpecial,
  selectTrialInDays,
} from '../../../store/selectors';

import styles from './LeftPaymentText.module.css';

const LeftPaymentText = ({ plan }) => {
  const trialInDays = useSelector(selectTrialInDays);
  const plans = useSelector(selectPlans);
  const planDetails = useSelector(selectPlanDetails);
  const isSpecial = useSelector(selectSpecial);
  const paymentType = useSelector(selectPaymentType);
  const billingPrice = plans?.[plan]?.price[`${paymentType}_price_off`] ?? plans?.[plan]?.price[`${paymentType}_price`];
  const period = paymentType == 'month' ? 'month' : 'year';
  return (
    <div className={styles.leftText}>
      {trialInDays && trialInDays > 0 ? (
        <div>
          <p>
            Your <strong>{trialInDays}-Day Trial</strong> is completely free and lasts until{' '}
            <strong>
              {moment()
                .add(trialInDays, 'days')
                .format('MMM D, YYYY')}
              .
            </strong>{' '}
            Cancel any time.
          </p>

          <p className={styles.title}>Will my credit card be charged right now?</p>

          <p>
            No. you won’t be charged until after your free trial ends on{' '}
            {moment()
              .add(trialInDays, 'days')
              .format('MMM D, YYYY')}
            . After your free trial, you’ll be charged{' '}
            {isSpecial ? planDetails?.price : plans?.[plan]?.price[paymentType]} (plus tax) until you decide to
            downgrade or cancel.
          </p>
        </div>
      ) : (
        <div>
          <p className={styles.title}>How much will I be billed today?</p>
          <p>You’ll be billed ${billingPrice} today for your first {period}.</p>
          <p className={styles.title}>How much will I be billed in the future?</p>
          <p>After your first {period} you will be billed {plans?.[plan]?.price[paymentType]}, which is the
          regular price for the Create plan.</p>
        </div>
      )}

      <p className={styles.title}>Can I change my plan?</p>

      <p>
        Yes, you can downgrade, cancel your subscription, or switch to a new plan any time you like by going to Your
        Account in the dashboard".
      </p>
    </div>
  );
};

export default LeftPaymentText;
